import { FolkSyntaxAttribute } from '../folk-syntax';
FolkSyntaxAttribute.define();
export { FolkSyntaxAttribute };
//# sourceMappingURL=folk-syntax-attribute.js.map